import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import usePasteWidget from "../../../hooks/usePasteWidget";
import { TYPE_INFOGRAPHIC, TYPE_PROPOSAL } from "../../../constants/editor";
import { getZoomedValue } from "../../../_helpers/utils";
import { EditorPanelContext } from "../../../containers/editor/EditorPanel";

let style = Object.assign({}, global);

const Paste = props => {
  let { rightContextMenu, updateRightContextMenu, metadata, documentType, dimension } = useContext(EditorContext);
  let { keyBoardEvent, updateKeyBoardEvent } = useContext(EditorPanelContext);

  const { pasteObj } = usePasteWidget();

  const [isMac, setIsMac] = useState();

  const pasteMethod = () => {
    let parentRect = document.querySelector(".generic-editor-wrap").getBoundingClientRect();
    let leftAreaRect = document.querySelector(".editor-wrapper").getBoundingClientRect();
    let targetLeft = rightContextMenu.style.left + leftAreaRect.left - parentRect.left;
    let targetTop = rightContextMenu.style.top + leftAreaRect.top - parentRect.top;

    if ([TYPE_INFOGRAPHIC, TYPE_PROPOSAL].includes(documentType)) {
      let totalHeight = 0;
      document.querySelectorAll(".dhp-page-block").forEach(element => {
        if (parseInt(element.getAttribute("data-block-idx")) < metadata.activeBlockIdx) {
          let zoomedHeight = getZoomedValue(parseFloat(element.style.height), dimension.zoom);
          totalHeight = totalHeight + zoomedHeight;
        }
      });
      targetTop = targetTop - totalHeight;
    } else {
      targetTop =
        targetTop -
        (parseFloat(document.querySelector(".dhp-page-canvas").style.height) * metadata.activeBlockIdx +
          24 * metadata.activeBlockIdx);
    }

    updateKeyBoardEvent({ ...keyBoardEvent, paste: true });

    if (props.rightContext) {
      pasteObj(targetLeft, targetTop);
      updateRightContextMenu({
        ...rightContextMenu,
        enable: false,
      });
    } else pasteObj();
  };

  useEffect(() => {
    let isMacOS = /Mac/i.test(navigator.platform) || /Macintosh/i.test(navigator.userAgent);
    setIsMac(isMacOS);
  }, []);

  return (
    <li
      className={cx({
        [style["custom-tooltip"]]: !props.rightContext,
      })}>
      <span className={style["toolset-action"]} onClick={pasteMethod}>
        <Icon icon="ui-paste" />
        {props.rightContext && (
          <>
            Paste{isMac && <span>Cmd+V</span>}
            {!isMac && <span>Ctrl+V</span>}
          </>
        )}
      </span>
      {!props.rightContext && <div className={style["custom-tooltip-content"]}>Paste</div>}
    </li>
  );
};

Paste.propTypes = {
  rightContext: PropTypes.bool,
};

export default Paste;
